module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan2-2-4c2dfc67121a1ef5438f9b6caeb14370.webp";